import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/contact";

export const About = ({ t }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [-50, 50]);

  return (
    <section id="apresentacao" ref={ref} className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40" data-testid="about-section">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold" data-testid="about-chapter">
                {t.about.chapter}
              </p>
              <h2 className="mt-4 font-display text-4xl tracking-tight text-bone sm:text-5xl" data-testid="about-title">
                {t.about.title}
              </h2>
              <div className="mt-6 h-px w-16 bg-gold" />
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <Reveal>
            <p className="font-display text-2xl italic leading-snug text-bone sm:text-3xl" data-testid="about-heading">
              {t.about.heading}
            </p>
          </Reveal>

          <div className="mt-10 space-y-8">
            {t.about.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.08 * i}>
                <p className="max-w-2xl text-base leading-relaxed text-bone/70 sm:text-lg" data-testid={`about-paragraph-${i}`}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div className="mt-14 grid grid-cols-3 gap-6 border-y border-white/10 py-8" data-testid="about-stats">
              {t.about.stats.map((s) => (
                <div key={s.label}>
                  <p className="font-mono text-2xl text-gold sm:text-3xl">{s.value}</p>
                  <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-bone/50">{s.label}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <figure className="relative mt-14 overflow-hidden rounded-sm border border-white/10" data-testid="about-image-frame">
              <motion.img
                style={{ y: imgY }}
                src={IMAGES.about}
                alt={t.about.imageCaption}
                className="h-[420px] w-full scale-110 object-cover"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
              <figcaption className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-bone/70">
                {t.about.imageCaption}
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
